<template>
  <router-link :to="routeLink">
    <div class="profile" :style="{backgroundImage: `url(${article.thumbnail_image_url})`}">
      <div class="profile-bar flex" :class="profileBarClass">
        <div class="profile-name">
          <p class="body-11">{{ article.first_name }}</p>
          <p class="body-5 uppercase">{{ article.last_name }}</p>
        </div>
        <div v-if="showArticleCategoryIcon" class="sport-icon" :class="categorySlug"></div>
      </div>
      <div class="overlay" :class="categorySlug"></div>
    </div>
  </router-link>
</template>

<script>
  export default {
    name: 'PlayerProfileLink',

    props: {
      article: {
        default: null,
        type: Object
      },
      showArticleCategoryIcon: {
        default: true,
        type: Boolean
      }
    },

    data() {
      return {
        ADMIN_API_HOST: process.env.VUE_APP_ADMIN_HOST,
      }
    },

    computed: {
      categorySlug: function () {
        if (this.article.categories.length) {
          return this.article.categories[0].slug;
        }

        return 'default';
      },

      lgFirstName: function() {
        if (this.showArticleCategoryIcon) {
          return this.article.first_name && this.article.first_name.length > 17;
        }

        return this.article.first_name && this.article.first_name.length > 22;
      },

      lgLastName: function() {
        if (this.showArticleCategoryIcon) {
          return this.article.last_name && this.article.last_name.length > 9;
        }

        return this.article.last_name && this.article.last_name.length > 12;
      },

      hasLgName: function() {
        return this.lgFirstName || this.lgLastName;
      },

      profileBarClass: function() {
        return {
          lg: this.hasLgName,
          [this.categorySlug]: true
        }
      },

      routeLink: function () {
        return {
          name: 'article',
          params: {
            category: this.categorySlug,
            article: this.article.slug,
          }
        };
      }
    }
  }
</script>

<style lang="scss" scoped>
  .profile {
    position: relative;
    background-size: cover;
    background-position: center center;
    height: 200px;

    .profile-bar {
      align-items: center;
      pointer-events: none;
      width: 200px;
      height: 46px;
      bottom: config('negativeMargin.3');
      border-radius: 0 50px 50px 0;
      @apply justify-between pin-l z-10 absolute;

      &.lg {
        width: 100%;
      }

      &.basketball {
        @apply bg-c1-b;
      }

      &.football {
        @apply bg-c2-b;
      }

      &.baseball {
        @apply bg-c3-b;
      }

      &.soccer {
        @apply bg-c4-b;
      }

      &.more-sports {
        @apply bg-c5-b;
      }

      &.olympics {
        @apply bg-c6-b;
      }

      &.hockey {
        @apply bg-c7-b;
      }

      &.tennis {
        @apply bg-c8-b;
      }

      &.default {
        @apply bg-grey-1;
      }

      .sport-icon {
        position: relative;
        display: block;
        margin: auto 5px;
        width: 35px;
        height: 35px;

        &.basketball {
          background: no-repeat url("../../assets/images/34-lrn-spt-feat-car-bar-cat-1.svg");
        }

        &.football {
          background: no-repeat url("../../assets/images/35-lrn-spt-feat-car-bar-cat-2.svg");
        }

        &.baseball {
          background: no-repeat url("../../assets/images/36-lrn-spt-feat-car-bar-cat-3.svg");
        }

        &.soccer {
          background: no-repeat url("../../assets/images/37-lrn-spt-feat-car-bar-cat-4.svg");
        }

        &.more-sports {
          background: no-repeat url("../../assets/images/38-lrn-spt-feat-car-bar-cat-5.svg");
        }

        &.olympics {
          background: no-repeat url("../../assets/images/olympics-category-circle-icon.svg");
        }

        &.hockey {
          background: no-repeat url("../../assets/images/hockey-category-circle-icon.svg");
        }

        &.tennis {
          background: no-repeat url("../../assets/images/tennis-category-circle-icon.svg");
        }
      }
    }

    .profile-name {
      p {
        @apply text-white ml-3 my-0 leading-none;
      }
    }

    .overlay {
      height: 200px;
      position: absolute;
      width: 100%;

      &:hover {
        transition: background-color .25s ease;

        &.basketball {
          @apply bg-c1-c;
        }

        &.football {
          @apply bg-c2-c;
        }

        &.baseball {
          @apply bg-c3-c;
        }

        &.soccer {
          @apply bg-c4-c;
        }

        &.more-sports {
          @apply bg-c5-c;
        }

        &.olympics {
          @apply bg-c6-c;
        }

        &.hockey {
          @apply bg-c7-c;
        }

        &.tennis {
          @apply bg-c8-c;
        }
      }
    }
  }
</style>
